import { useEffect } from "react";

/**
 * Canonical da pagina publica. Nao fica no index.html porque aquele HTML e
 * servido em toda rota da SPA: com o canonical fixo la, a vitrine de cada loja
 * diria ao Google que e copia da landing.
 */
export function useCanonical(url: string) {
  useEffect(() => {
    const link = document.createElement("link");
    link.rel = "canonical";
    link.href = url;
    document.head.appendChild(link);
    return () => link.remove();
  }, [url]);
}
